import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  warning: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 0),
    backgroundColor: theme.colorPalette.green_100,
    color: theme.onCard.white,
    justifyContent: 'center',
    ...reskinStyles(theme, { backgroundColor: theme.colorPalette.beige_25, borderRadius: theme.sizes.innerCorners })
  },
  icon: {
    width: 16,
    height: 16
  }
});

export default makeStyles(styles);
